import { useEffect, useState } from 'react';
import c from './Landing.module.css';
import { TERM_SCRIPT } from './data';

const VISIBLE = 7;
const INTERVAL_MS = 1800;

export function AgentTerminal() {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => setTick((t) => t + 1), INTERVAL_MS);
    return () => window.clearInterval(id);
  }, []);

  const len = TERM_SCRIPT.length;
  const lines = Array.from({ length: VISIBLE }, (_, i) => {
    const pos = tick + i;
    // Key by absolute position so only the newly-entering line animates in.
    return { key: pos, ...TERM_SCRIPT[pos % len] };
  });

  return (
    <div className={c.termWrap}>
      <div className={c.termGlow} />
      <div className={c.term}>
        <div className={c.termBar}>
          <div className={c.termDots}>
            <span style={{ background: '#ef4444' }} />
            <span style={{ background: '#f5b849' }} />
            <span style={{ background: '#34d399' }} />
          </div>
          <span className={c.termTitle}>exonstech — agent-pipeline · live</span>
          <span className={c.termStatus}><span />RUNNING</span>
        </div>
        <div className={c.termBody} aria-live="off">
          {lines.map((ln) => (
            <div key={ln.key} className={c.termLine}>
              <span className={c.termMark} style={{ color: ln.color }}>{ln.mark}</span>
              <span className={c.termText}>
                <span className={c.termAgent} style={{ color: ln.agentColor }}>{ln.agent}</span> {ln.text}
              </span>
            </div>
          ))}
          <div className={c.cursorRow}>
            <span className={c.termMark}>$</span>
            <span className={c.cursor} />
          </div>
        </div>
        <div className={c.termProgress}><div className={c.beam} /></div>
      </div>
    </div>
  );
}
